export type StatusFilterOption = {
  title: string;
  value: string;
};

export const CUSTOMER_STATUS_FILTERS: StatusFilterOption[] = [
  { title: "Aguardando", value: "WAITING" },
  { title: "Pendente", value: "PENDING" },
  { title: "Pré-registrado", value: "PRE_REGISTRATION" },
  { title: "Ativos", value: "ACTIVE" },
  { title: "Atualizar registro", value: "RE_REGISTRATION" },
  { title: "Bloqueados", value: "BLOCKED" },
  { title: "Cancelados", value: "CANCELED" },
];

export const PARTNER_STATUS_FILTERS: StatusFilterOption[] = [
  { title: "Pendente", value: "PENDING" },
  { title: "Aguardando", value: "WAITING" },
  { title: "Prospectado", value: "PROSPECTADO" },
  { title: "Pré-registrado", value: "PRE_REGISTRATION" },
  { title: "Ativos", value: "ACTIVE" },
  { title: "Bloqueados", value: "BLOCKED" },
  { title: "Cancelados", value: "CANCELED" },
];

export const CUSTOMER_REVIEW_STATUSES = new Set([
  "WAITING",
  "PENDING",
  "PRE_REGISTRATION",
  "RE_REGISTRATION",
]);

export const PARTNER_REVIEW_STATUSES = new Set([
  "PENDING",
  "WAITING",
  "PRE_REGISTRATION",
  "PROSPECTADO",
]);
